import { Location, CenterZoom } from 'lib/types'

import { featureCollection as turfFeatureCollection, point as turfPoint } from '@turf/helpers'
import turfCircle from '@turf/circle'
import geoViewport from '@mapbox/geo-viewport'
import turfBbox from '@turf/bbox'

export const hasLatitudeLongitude = (l: Location): boolean =>
  typeof l.latitude !== 'undefined' && typeof l.longitude !== 'undefined'

export const hasRadius = (l: Location): boolean => typeof l.radius !== 'undefined'

export default function centerZoomFromLocations (
  locations: Location[],
  width = 564,
  height = 300,
  padding = 20
): CenterZoom {
  const features = turfFeatureCollection(
    locations.filter(hasLatitudeLongitude).map(location => {
      const point = turfPoint([location.longitude, location.latitude])

      if (hasRadius(location)) {
        return turfCircle(point, location.radius)
      }

      return point
    })
  )

  const bounds = turfBbox(features)

  const { center, zoom } = geoViewport.viewport(bounds, [width - padding * 2, height - padding * 2])

  return {
    center: [center[1], center[0]],
    zoom: Math.min(zoom, 13)
  }
}
